import { useState, useEffect } from 'react'

export default function DigitalClock({ slot }) {
  const [time, setTime] = useState(new Date())

  useEffect(() => {
    const interval = setInterval(() => {
      setTime(new Date())
    }, 1000)

    return () => clearInterval(interval)
  }, [])

  const hours = time.getHours().toString().padStart(2, '0')
  const minutes = time.getMinutes().toString().padStart(2, '0')
  const seconds = time.getSeconds().toString().padStart(2, '0')

  return (
    <div
      style={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
        color: 'white',
        fontFamily: 'monospace',
        userSelect: 'none',
      }}
    >
      <div style={{ fontSize: '48px', fontWeight: 'bold', letterSpacing: '4px' }}>
        {hours}:{minutes}:{seconds}
      </div>
      <div style={{ fontSize: '14px', opacity: 0.8, marginTop: '8px' }}>
        {time.toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}
      </div>
    </div>
  )
}
